import { render, staticRenderFns } from "./UtilityCard.vue?vue&type=template&id=5566211b&scoped=true&"
import script from "./UtilityCard.vue?vue&type=script&lang=js&"
export * from "./UtilityCard.vue?vue&type=script&lang=js&"
import style0 from "./UtilityCard.vue?vue&type=style&index=0&id=5566211b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5566211b",
  null
  
)

export default component.exports